// extracted by mini-css-extract-plugin
export default {"logo_modul":"Logo_logo_modul__57MFe","logo":"Logo_logo__xq-Lr"};